export enum SearchParam {
  InvitationHash = "invitation_hash",
  EmailToken = "email_token",
  Intent = "intent",
  // App auth uses 'beta' string so I kept it for consistency but
  // it means beta app type not beta env so the enum name is BetaApp for clarification
  BetaApp = "beta",
}

export enum DeepLinkSearchParam {
  TeamID = "team",
  Environment = "env",
}

export enum SearchParamIntent {
  Share = "share",
}
